import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import http from "../httpService"

export interface IContractInterestSetting {
  id?: number
  contractId: number
  interestRate?: number
  interestRateTimeType?: number
  interestRateFreeIn?: number
  feeTypeIds?: number[]
  ignoreHolidays?: boolean
  isInterestIncludeVat?: boolean
  /** 0 = chỉ dùng ngày nhập, 1 = + ngày DA, 2 = + ngày SPA/LTL (lấy ngày muộn hơn) — InterestStartDateTypeEnum */
  interestStartDateType?: number
  /** ISO; trước ngày này không tính lãi. null = không giới hạn */
  interestStartDate?: string | null
  /** PhaseCode.id các đợt không tính lãi; [] = mọi đợt đều tính lãi */
  nonInterestPhaseCodeIds?: number[]
}

class ContractInterestSettingService {
  public async get(contractId: number): Promise<IContractInterestSetting | null> {
    const res = await http.get("api/services/app/ContractInterestSetting/GetByContractId", {
      params: { contractId },
    })
    return res.data.result ?? null
  }

  public async createOrUpdate(body: IContractInterestSetting): Promise<IContractInterestSetting> {
    const res = await http.post(
      "api/services/app/ContractInterestSetting/CreateOrUpdate",
      body
    )
    notifySuccess(LNotification("SUCCESS"), LNotification("SAVE_SUCCESSFULLY"))
    return res.data.result
  }

  public async delete(id: number): Promise<void> {
    await http.delete("api/services/app/ContractInterestSetting/Delete", {
      params: { id },
    })
    notifySuccess(LNotification("SUCCESS"), LNotification("DELETED_SUCCESSFULLY"))
  }
}

export default new ContractInterestSettingService()
